import styled from '@emotion/styled';
import HtmlParser from '../../HtmlParser';
import { __t } from '../../i18n';
import { Box, Text } from '../../styles';
import { deepMerge } from '../../utils';
import { BreakPointsOnly } from '../../theme';

interface ContentSummaryProps {
  html: string;
  title?: string;
  summeryOffset?: BreakPointsOnly
}

const ContentSummary = ({ html, title, summeryOffset }: ContentSummaryProps) => {
  return (
    <Container mb={4} ml={{ md: 4 }}>
      {html && html?.length > 3  ? <><Text variant="h2" weight="medium" mb={1}>
        {title || __t('content.summary')}
      </Text><SummaryWrapper weight="light" summeryOffset={summeryOffset}>
        <HtmlParser data={html} />
      </SummaryWrapper></> : ''}
    </Container>
  );
};

const Container = styled(Box)(() => ({
  position: 'relative',
}));

const containerWidthOffset: BreakPointsOnly = {
  md: '39rem',
};
const SummaryWrapper = styled(Text)<{ summeryOffset?: BreakPointsOnly }>(({ theme, summeryOffset = containerWidthOffset }) => {
  const responsiveOffset = theme.mixins.create(summeryOffset, (p) => ({ maxWidth: p }));
  return deepMerge(responsiveOffset);
});

export default ContentSummary;
